import script from "./AppleDownloadDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AppleDownloadDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AppleDownloadDrawer.vue?vue&type=style&index=0&id=e3507baa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3507baa"]])

export default __exports__